import { render, staticRenderFns } from "./ArticleManagement.vue?vue&type=template&id=0f524ad0&scoped=true&"
import script from "./ArticleManagement.vue?vue&type=script&lang=js&"
export * from "./ArticleManagement.vue?vue&type=script&lang=js&"
import style0 from "./ArticleManagement.vue?vue&type=style&index=0&id=0f524ad0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f524ad0",
  null
  
)

export default component.exports